'use strict';

angular.module('msLegacyActivities').controller('SectionCtrl', ['$scope', '$document', '$state', '$stateParams', '$timeout', 'NotifyingSvc', 'smoothScroll', 'overlaySvc', 'widgetSvc', 'preloader', 'section', function ($scope, $document, $state, $stateParams, $timeout, NotifyingSvc, smoothScroll, overlaySvc, widgetSvc, preloader, section) {
  // find the section that we want
  $scope.findSection = function (uuid) {
    return $scope.activity.sections.filter(function (section) {
      return section.uuid === uuid;
    })[0];
  };
  $scope.section = section;
  $scope.currentSection = $scope.section.position + 1;
  // This is just used to change the way the cards are animated.
  $scope.activityStage = 'activity-stage-inProgress';
  $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;

  // Wait an abritrary 2s before running this.
  // Just to let the browser/angular catch up.
  var _preloadTimer = $timeout(function () {
    // Run thorugh the current section's widgets to find the "next section" button.
    var nextSectionId = widgetSvc.getNextSection($scope.section);
    preloader.preloadImages(widgetSvc.getActivitySectionImages($scope.activity, nextSectionId));
  }, 2000);

  $scope.showCommunityGuidelines = function () {
    overlaySvc.overlay('youth.overlay.community_guidelines', {
      icon: 'fa fa-thumbs-up'
    });
  };

  $scope.next = function (nextSection) {
    smoothScroll($('body')[0], {
      duration: 500
    });

    // Cancel any prefeching since it is going to get called anyway.
    $timeout.cancel(_preloadTimer);

    $state.go('activity.section', {
      section: nextSection
    }).then(function () {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.ACTIVITY_PAGE, {});
    });
  };
}]);